import React from 'react'
import {MyJobs} from '../Pages/MyJobs/MyJobs'

function Myjobs() {
  return (
    <>
        <MyJobs />
    </>
  )
}

export default Myjobs
